// extracted by mini-css-extract-plugin
export default {"post":"SinglePost_post__mmmVR"};